import { Button, Col, Divider, Row } from "antd";
import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { getUserStatus } from "../../../models/user/enum";
import { languages } from "../../../utils/helpers/constants";
import FieldBuilder from "../../form-components/field-builder";
import Spin from "../../general/antd/spin";
import OldImage from "../../form-components/old-image";
import FormItem from "../../general/form-item";
import Controller from "../../form-components/controller";
import ImageUploader from "../../form-components/image-uploader";
import { MediumFor } from "../../../models/medium/enum";
import EndPoints from "../../../services/end-points";
import { useState } from "react";
import AppContext from "../../../context/app/context";
import { getTranslations } from "../../../utils/helpers/translations";
import TrademarkManagerContext from "../../../context/trademark-manager/context";
import { IUpdateTradmarkManager } from "../../../models/trademark-manager/request";
import { ITrademarkLight } from "../../../models/trademark-manager/response";
import TrademarkManagerContextProvider from "../../../context/trademark-manager/provider";
import { FormProvider, useForm } from "react-hook-form";
import styles from "./style.module.scss";
import { execute } from "../../../utils/helpers/execute";

const Form = () => {
  const { t } = useTranslation();
  const { details, actions, loading } = useContext(TrademarkManagerContext);
  const [trademarks, setTrademarks] = useState<ITrademarkLight[]>([]);
  const [trademarksLoading, setTrademarksLoading] = useState<boolean>(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const { direction } = useContext(AppContext);

  const navigate = useNavigate();
  const { id } = useParams();
  const status = [1, 2];
  useEffect(() => {
    const getDetails = async () => {
      id && (await actions.getDetails(Number(id)));
    };
    getDetails();
  }, []);

    useEffect(() => {
      const getTradmarks = async () => {
        try {
          const { data } = await EndPoints.trademark.getAllTrademark({
            light: true,
            perPage: -1,
          });
          setTrademarks(data.data);
          setTrademarksLoading(false);
        } catch (error) {
        } finally {
          setTrademarksLoading(false);
        }
      };
      getTradmarks();
    }, [direction]);

    const methods = useForm<any>({
      defaultValues: {
        trademarkId: details?.trademark?.id ,
          email: details?.user?.email,
          firstName: details?.user?.firstName,
          imageId: details?.user?.image?.id ?? undefined,
          lastName: details?.user?.lastName,
          mobile: details?.user?.cleanMobile,
          note: getTranslations(details?.user?.translations?.note) ?? null,
          phone: details?.user?.phone,
          status: details?.user?.status,
          password: details?.user.password,
        } as IUpdateTradmarkManager
    });

    const {
      handleSubmit,
      reset,
    } = methods;

    useEffect(() => {
      reset({
        trademarkId: details?.trademark?.id ,
        email: details?.user?.email,
        firstName: details?.user?.firstName,
        imageId: details?.user?.image?.id ?? undefined,
        lastName: details?.user?.lastName,
        mobile: details?.user?.cleanMobile,
        note: getTranslations(details?.user?.translations?.note) ?? null,
        phone: details?.user?.phone,
        status: details?.user?.status,
        password: details?.user.password,
      } as IUpdateTradmarkManager);
    }, [details]);

    const onSubmit = async (data: any) => {
      await execute({
        callback: async () => {
          setLoadingSubmit(true);
          details
            ? await EndPoints.trademarkManager.updateTrademarkManager(details?.id,data)
            : await EndPoints.trademarkManager.createTrademarkManager(data);
          navigate(-1);
        },
        fallback: () => {},
        finallyCallback: () => {
          setLoadingSubmit(false);
        },
        throwException: false,
      });
    };

  return (
 <>
 <FormProvider {...methods}>
  <form className={styles.container} style={{padding: "20px"}} onSubmit={handleSubmit(onSubmit)}>
    <div>
      <span className={styles.title}>
          {details ? t("update_user") : t("add_user")}
      </span>
      <Divider className={styles.divider} />
          {loading.includes("details") ? (
            <div style={{ height: "60vh" }}>
              <Spin />
            </div>
          ):(
            <>
            <Row gutter={[16, 8]}>
              <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={8}>
                <FieldBuilder
                  name="firstName"
                  label={t("first_name")}
                  input={{ type: "text" }}
                  rules={{ required: true }}
                />
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={8}>
                <FieldBuilder
                  name="lastName"
                  label={t("last_name")}
                  input={{ type: "text" }}
                  rules={{ required: true }}
                />
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={8}>
                <FieldBuilder
                  name="email"
                  label={t("email")}
                  input={{ type: "email" }}
                  rules={{ required: true }}
                />
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={8}>
                <FieldBuilder
                  name="password"
                  label={t("password")}
                  input={{ type: "password" }}
                  rules={{ required: details?.id ? false : true }}
                />
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={8}>
                <FieldBuilder
                  name="mobile"
                  label={t("mobile")}
                  input={{ type: "text" }}
                  rules={{ required: true }}
                />
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={8}>
                <FieldBuilder
                  name="phone"
                  label={t("phone")}
                  input={{ type: "text" }}
                  rules={{ required: false }}
                />
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={8}>
                <FieldBuilder
                  name="status"
                  label={`${t("status")}`}
                  width="large"
                  rules={{ required: true }}
                  input={{
                    type: "select",
                    loading: false,
                    options: status?.map((state, index) => {
                      return {
                        key: index,
                        label: t(getUserStatus(state)),
                        value: state,
                      };
                    }),
                  }}
                />
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={8}>
                <FieldBuilder
                  name="trademarkId"
                  label={`${t("trademark")}`}
                  width="large"
                  rules={{ required: true }}
                  input={{
                    type: "select",
                    loading: trademarksLoading,
                    allowSearch: true,
                    options: trademarks?.map((trademark, index) => {
                      return {
                        key: index,
                        label: trademark.name,
                        value: trademark.id,
                      };
                    }),
                  }}
                />
              </Col>
              {languages?.map((lang, index) => {
                return (
                  <Col span={12}>
                    <FieldBuilder
                      key={index}
                      name={`note[${lang?.code}]`}
                      label={`${t("note")} (${lang?.name})`}
                      input={{ type: "text-area" }}
                      rules={{ required: false }}
                    />
                  </Col>
                );
              })}
              <Col span={24}>
                <FormItem label={t("image")}>
                  <Controller
                    name="imageId"
                    rules={{
                      required: {
                        value: false,
                        message: `${t("field_is_required_message")}`,
                      },
                    }}
                    render={({ field: { ref, ...field } }) => {
                      return (
                        <ImageUploader
                          {...field}
                          type="DRAGGER"
                          onChange={(response) => {
                            // setfileId(response);
                            field.onChange(response?.id);
                          }}
                          imageFor={MediumFor.UserProfile}
                        />
                      );
                    }}
                  />
                </FormItem>
              </Col>
              {details?.user?.image && (
                <OldImage src={details?.user?.image?.url} />
              )}
            </Row>
          </>
          )}
    </div>
    <div>
      <div className={styles.formFooter}>
        <Button
          onClick={() => {
            navigate(-1);
          }}
        >
          {t("cancel")}
        </Button>
        <Button loading={loadingSubmit} htmlType="submit" type="primary">
          {t("save")}
        </Button>
      </div>
      </div>
  </form>
 </FormProvider>
 </>
  );
};

const TrademarkManagerForm = () => {
  return (
    <TrademarkManagerContextProvider>
      <Form />
    </TrademarkManagerContextProvider>
  );
};
export default TrademarkManagerForm;
